import React from 'react';
import { Immutable } from 'nuclear-js';
import reactor from 'data/reactor';
import RuntimeGetters from 'data/app-runtime/getters';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Highlights from './highlights';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

export default CreateReactClass({
    displayName: 'highlights-container',
    mixins: [DeepCompareComponentShouldUpdateMixin],

    propTypes: {
        highlights: PropTypes.instanceOf(Immutable.Map),
        toggleHighlightsFn: PropTypes.func.isRequired,
        selectedSubject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            showAllHighlights: false,
            showHighlightText: CommonStrings.highlights.showMore,
            showMoreTextClass: 'showMoreText closeTriangle',
        };
    },

    render() {
        const highlightsForSubject = this.props.highlights
            ? this.props.highlights.get(this.props.selectedSubject.get('bid'))
            : null;
        const subjectHighlights = (
            <Highlights
                key={`highlights-${this.props.selectedSubject.get('shortName')}`}
                subject={this.props.selectedSubject}
                highlights={highlightsForSubject}
                toggleHighlightsFn={this.props.toggleHighlightsFn}
            />
        );

        let classes = this.props.highlights != null && this.props.highlights.size > 0 ? 'highlights-container' : '';
        classes = this.state.togglingHighlights ? 'highlights-container toggling' : classes;
        return <div className={classes}>{subjectHighlights}</div>;
    },
});
